import {ZIDX, ZIDXPage} from "../standaloneLibrary.js";
import jQuery from "jquery";
import {AIChatBox, AIChatBoxConfig} from "./AIChatBox.js";
const $ = jQuery;

export class ZIDXAIChat implements ZIDXPage {
    zidx: ZIDX;
    private aiSessionId: string | null = null;
    private aiChatBox: AIChatBox | null = null;
    private pageContainer: HTMLElement | null = null;

    constructor(zidx: ZIDX) {
        this.zidx = zidx;
    }

    getPageClass() {
        return "zidxAIChatContainer";
    }

    render() {
        const self = this;
        const pageContainer = $("." + this.getPageClass() + ".zidxPageActive", this.zidx.peakidxShadowRoot)[0];
        if (!pageContainer) return;
        this.pageContainer = pageContainer;
        const chatEmbed = $("." + this.getPageClass() + ".zidxPageActive .aifcChatEmbed", this.zidx.peakidxShadowRoot)[0];
        if (!chatEmbed) return;

        const restoreSessionId = this.getSessionIdFromContainer(pageContainer);

        const config = new AIChatBoxConfig();
        config.aiEndPointURL = "/ai/";
        config.aiBotId=0;

        // Triggers AIChatBox.loadSessionHistory() -> renderHistoryMessages() -> onHistoryLoaded
        if (restoreSessionId) {
            config.initialSessionId = restoreSessionId;
            this.aiSessionId = restoreSessionId;
        }

        // Fires once the backend assigns/confirms the session id (new or restored)
        config.onSessionReady = (sessionId: string) => {
            self.aiSessionId = sessionId;
            self.pushSessionURL(sessionId);
        };

        config.onPromptCallback = (prompt: string) => prompt;
        config.onText = (data: string): string => data;
        config.onJSON = (data: any) => {};
        config.onXML = (data: string) => {};

        config.onHistoryLoaded = (messages: any[]) => {
            // renderHistoryMessages leaves stale loading dots behind; strip them.
            self.removeAllLoadingDots();
        };

        config.onDataCompleteCallback = () => {};

        this.aiChatBox = new AIChatBox(this.zidx, config, this.zidx.peakidxShadowRoot, chatEmbed, function() {});
    }

    private getSessionIdFromContainer(pageContainer: HTMLElement): string | null {
        // window.location is NOT yet updated when render() runs during SPA navigation
        // (pushState fires afterward in a setTimeout inside renderResponse). renderResponse
        // sets data-last-url on the active container before calling render(), and so does
        // runLoadFunctions on refresh — so it's correct in both paths.
        const lastURL = pageContainer.getAttribute("data-last-url") || "";
        const qIdx = lastURL.indexOf("?");
        // No query string means genuinely no sessionId — do NOT fall back to
        // window.location.search, that's the stale value that caused this bug.
        const search = qIdx !== -1 ? lastURL.substring(qIdx) : "";

        const fromQuery = new URLSearchParams(search).get("sessionId");
        if (fromQuery && /^[a-zA-Z0-9_-]+$/.test(fromQuery)) {
            return fromQuery;
        }
        return null;
    }

    private pushSessionURL(sessionId: string) {
        if (!this.pageContainer
            || !this.pageContainer.classList.contains("zidxPageActive")
            || !(this.zidx.peakidxShadowRoot as ParentNode).contains(this.pageContainer)) {
            return;
        }

        const lastURL = this.pageContainer.getAttribute("data-last-url") || "";
        const url = new URL(this.zidx.options.siteDomain+lastURL);
        if (url.searchParams.get("sessionId") === sessionId) return;
        url.searchParams.set("sessionId", sessionId);
        // lastURL is root-relative; keep the site prefix (wordpress proxy, cdn) in the browser address
        window.history.replaceState({ aiChatSession: sessionId }, "", this.zidx.getPrefixURL(url.pathname) + url.search + url.hash);
    }

    private removeAllLoadingDots() {
        const root = this.zidx.peakidxShadowRoot;
        $(".aifcChatLoadingDots", root).remove();
        $(root).find("#aifcCurrentLoader").remove();
    }
}